import { useCallback } from 'react';

import { useQueryClient } from 'react-query';
import { useChannel, useEvent } from '@harelpls/use-pusher';

export const usePublicQuestionsChannel = (roomId?: number) => {
  const queryClient = useQueryClient();

  const publicQuestionsChannel = useChannel(`room.${roomId}.public-questions`);

  const handleQuestionCreated = useCallback(() => {
    if (!roomId) return;
    queryClient.invalidateQueries(['public-questions', roomId]);
  }, [queryClient, roomId]);

  const handleQuestionVoted = useCallback(() => {
    if (!roomId) return;
    queryClient.invalidateQueries(['public-questions', roomId]);
  }, [queryClient, roomId]);

  useEvent(
    publicQuestionsChannel,
    'PublicQuestionCreated',
    handleQuestionCreated,
  );
  useEvent(publicQuestionsChannel, 'PublicQuestionVoted', handleQuestionVoted);
};
